<template>
  <v-snackbar
    id="app-snackbar"
    v-model="show"
    :location="snackbar.y === 'top' ? 'top' : undefined"
    :multi-line="snackbar.mode === 'multi-line'"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    :class="snackbar.fontClass"
    :vertical="snackbar.mode === 'vertical'"
    class="pt-11"
  >
    <div
      v-if="snackbar.displayAsHtml"
      v-html="snackbar.text"
    />
    <span v-else>{{ snackbar.text }}</span>

    <template #actions>
      <a-btn
        v-if="snackbar.showBtn"
        variant="text"
        color="white"
        prepend-icon="mdi-close"
        @click="show = false"
      />
    </template>
  </v-snackbar>
</template>

<script setup>
import { ref } from 'vue'
import { useAppStore } from '@/stores/AppStore.js'
const appStore = useAppStore()
const snackbar = ref({})
const show = ref(false)

appStore.$subscribe((mut, state) => {
  if (state.snack.show) {
    snackbar.value = state.snack
    show.value = true
    appStore.snack.show = false
  }
})
</script>

<style scoped lang="scss">
#app-snackbar {
  z-index: 2410 !important;
}
</style>
